import type { EventProps } from '../api';
import { dayLabel, hoursPill, revealLabel, TYPE_LABEL, TYPE_LOOK } from '../format';
import { useVisitedVersion, visited } from '../state/visited';
import { IconCheck } from './icons';

/** One result in the list. The whole row links to the listing; "been there" is a separate toggle. */
export function EventCard({ ev, num, showDay }: { ev: EventProps; num: number | undefined; showDay: boolean }) {
  useVisitedVersion();
  const been = visited.has(ev.public_id);
  const look = TYPE_LOOK[ev.event_type] ?? TYPE_LOOK.other!;
  const hours = hoursPill(ev.start_at, ev.end_at, ev.timezone, ev.end_time_unknown);
  const where = ev.is_online_only
    ? `Online, ${ev.city}, ${ev.state}`
    : ev.approximate
      ? `Near ${ev.city}, ${ev.state}`
      : `${ev.venue_name ? `${ev.venue_name}, ` : ''}${ev.address_1}, ${ev.city}`;
  return (
    <li className={`result${been ? ' visited' : ''}`}>
      <div className="thumb" style={ev.thumb_url ? undefined : { background: look.bg }}>
        {ev.thumb_url ? <img src={ev.thumb_url} alt="" loading="lazy" /> : <span className="glyph" aria-hidden="true">{look.glyph}</span>}
        {num !== undefined && <span className="n" aria-hidden="true">{num}</span>}
      </div>
      <div className="result-body">
        <div className="result-title">
          <a href={`/e/${ev.public_id}`}>
            {num !== undefined && <span className="sr-only">Stop {num}: </span>}
            {ev.title}
          </a>
        </div>
        <div className="result-sub">
          {where}
          {ev.distance_mi !== undefined ? `, ${ev.distance_mi} mi` : ''}
        </div>
        <div className="result-meta">
          <span className="tag">{TYPE_LABEL[ev.event_type] ?? 'Sale'}</span>
          <span className="when">
            {showDay ? `${dayLabel(ev.start_at, ev.timezone)}, ` : ''}
            {hours}
          </span>
          {ev.recurrence_short && <span className="repeat">↻ {ev.recurrence_short}</span>}
          {ev.approximate && ev.address_reveal_at && (
            <span className="tag warn">Address at {revealLabel(ev.address_reveal_at, ev.timezone)}</span>
          )}
        </div>
      </div>
      <button
        type="button"
        className="been"
        aria-pressed={been}
        aria-label={been ? `Mark ${ev.title} as not visited` : `Mark ${ev.title} as visited`}
        title={been ? 'Been there' : 'Mark as been there'}
        onClick={() => visited.toggle(ev.public_id)}
      >
        <IconCheck />
      </button>
    </li>
  );
}
